module.exports = __webpack_public_path__ + "img/circle-bookmark.5d95bdfc.svg";